<template>
    <div>
        <div class="layout">
            <Sider :style="{position: 'fixed', height: '100vh', left: 0, overflow: 'auto'}">
                <p class="co-study">CoStudy 打卡日历</p>
                <Menu theme="dark" :active-name="selectedName[1]" width="auto" :open-names="[selectedName[0]]">
                    <Submenu name="打卡日历">
                        <template slot="title">
                            <Icon type="md-calendar" />
                            打卡日历
                        </template>
                        <MenuItem name="文案" to="/calendar/text">文案</MenuItem>
                        <MenuItem name="图片" to="/calendar/img">图片</MenuItem>
                    </Submenu>
                    <Submenu name="2">
                        <template slot="title">
                            <Icon type="ios-paper"></Icon>
                            其他
                        </template>
                        <MenuItem name="2-1">待定</MenuItem>
                    </Submenu>
                </Menu>
            </Sider>
            <Layout :style="{marginLeft: '200px'}">
                <Header :style="{position: 'fixed',width: 'calc(100vw - 200px)',padding: '0 16px',background: '#fff', boxShadow: '0 2px 3px 2px rgba(0,0,0,.1)'}">
                    <div class="header-box">
                        <div class="header-info">
                            <Breadcrumb :style="{margin: '0',display:'inline'}">
                                <BreadcrumbItem v-for="(item,index) in selectedName" :key="index">{{item}}
                                </BreadcrumbItem>
                            </Breadcrumb>
                        </div>
                        <div class="header-menu">
                            <ul>
                                <li>
                                    <a @click="home">
                                      <Icon type="ios-home" />首页
                                    </a>
                                </li>
                                <li><a @click="logout">
                                    <Icon type="ios-log-out"/>
                                    退出</a></li>
                            </ul>
                        </div>
                    </div>
                </Header>
                <Content :style="{margin: '80px 16px 0', background: '#fff', minHeight: 'calc(100vh - 80px)'}">
                    <router-view/>
                </Content>
            </Layout>
        </div>
    </div>
</template>
<script>
    import apis from '../../http/api'
    import common from "../../utils/utils";

    export default {
        name: 'CalendarHome',
        data() {
            return {
                selectedName: [],
                openName: ['打卡日历'],
                activeName: '文案'
            }
        },
        created() {
            this.updateSelectName()
        },
        watch: {
            // $route(to, from){
            //     this.selectedName = [];
            //     this.$route.matched.forEach(record => {
            //         if(typeof(record.name) === 'string' && record.name.length > 0){
            //             this.selectedName.push(record.name)
            //         }
            //     });
            // },
            '$route': 'updateSelectName'
        },
        methods: {
            test() {

            },
            updateSelectName() {
                this.selectedName = [];
                this.$route.matched.forEach(record => {
                    if (typeof (record.name) === 'string' && record.name.length > 0) {
                        this.selectedName.push(record.name)
                    }
                });
            },
            logout() {
                common.delToken()
                this.$router.push('/login')
            },
            home() {
              this.$router.push('/pages')
            },
        },

    }
</script>
<style scoped>
    .layout {
        border: 0 solid #d7dde4;
        background: #f5f7f9;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
    }

    .layout-header-bar {
        background: #fff;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
    }

    .co-study {
        text-align: center;
        padding: 15px 0;
        color: white;
        font-weight: bold;
        font-size: large;
    }

    .header-box {
        display: flex;
        justify-content: space-between;
    }

    .header-menu li {
        display: inline;
        margin-right: 10px;
    }

    .ivu-layout-header {
        z-index: 901;
    }
</style>